/* eslint-disable import/prefer-default-export */
import { MDText } from 'i18n-react';

import bankStatementExampleImage from '../../../../../../client/assets_seller/example_documents/bankStatement.jpg';
import councilTaxExampleImage from '../../../../../../client/assets_seller/example_documents/councilTax.jpg';
import deathCertificateExampleImage from '../../../../../../client/assets_seller/example_documents/deathCertificate.jpg';
import drivingLicenceExampleImage from '../../../../../../client/assets_seller/example_documents/drivingLicence.jpg';
import financeLetter1ExampleImage from '../../../../../../client/assets_seller/example_documents/financeLetter1.jpg';
import financeLetter2ExampleImage from '../../../../../../client/assets_seller/example_documents/financeLetter2.jpg';
import letterOfConsentExampleImage from '../../../../../../client/assets_seller/example_documents/letterOfConsent.jpg';
import passportExampleImage from '../../../../../../client/assets_seller/example_documents/passport.jpg';
import proofOfPurchaseAddressImage from '../../../../../../client/assets_seller/example_documents/proofOfAddress.jpg';
import proofOfPurchaseExampleImage from '../../../../../../client/assets_seller/example_documents/proofOfPurchase.jpg';
import solicitorsLetterExampleImage from '../../../../../../client/assets_seller/example_documents/solicitorsLetter.jpg';
import v5Page1ExampleImage from '../../../../../../client/assets_seller/example_documents/V5Page1.jpg';
import v5Page2ExampleImage from '../../../../../../client/assets_seller/example_documents/V5Page2.jpg';
import v5Page3ExampleImage from '../../../../../../client/assets_seller/example_documents/V5Page3.jpg';
import willExampleImage from '../../../../../../client/assets_seller/example_documents/will.jpg';
import { DOCUMENT_KIND_PROOF_OF_ADDRESS, DOCUMENT_KINDS } from '../../DocumentCapture.helpers';
import { DocumentKindsValue } from '../../DocumentCapture.types';
import LocalTexts from '../UploadDocuments.texts.json';

const LocalT = new MDText(LocalTexts);

export const EXAMPLE_DOCUMENTS: Record<Exclude<'additional_documents', DocumentKindsValue>, {
  checklist?: string[];
  images: {
    alt: string;
    src: React.ReactElement;
    title: string;
  }[];
  title?: string;
}> = {
  [DOCUMENT_KINDS.DRIVING_LICENCE]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.driving_licence.title') as string,
        src: drivingLicenceExampleImage,
        title: LocalT.translate('pages.driving_licence.inputs.frontSide.label') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.driving_licence.title') as string,
  },
  [DOCUMENT_KINDS.DEATH_CERTIFICATE]: {
    images: [
      {
        alt: LocalT.translate('exampleDocuments.death_certificate.title') as string,
        src: deathCertificateExampleImage,
        title: LocalT.translate('exampleDocuments.death_certificate.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.death_certificate.title') as string,
  },
  [DOCUMENT_KINDS.FINANCE_SETTLEMENT_LETTER]: {
    images: [
      {
        alt: LocalT.translate('exampleDocuments.finance_settlement_letter.title') as string,
        src: financeLetter1ExampleImage,
        title: LocalT.translate('pages.finance_settlement_letter.inputs.1stPage.label') as string,
      },
      {
        alt: LocalT.translate('exampleDocuments.finance_settlement_letter.title') as string,
        src: financeLetter2ExampleImage,
        title: LocalT.translate('pages.finance_settlement_letter.inputs.2ndPage.label') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.finance_settlement_letter.title') as string,
  },
  [DOCUMENT_KINDS.PROOF_OF_PURCHASE]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.proof_of_purchase.title') as string,
        src: proofOfPurchaseExampleImage,
        title: LocalT.translate('exampleDocuments.proof_of_purchase.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.proof_of_purchase.title') as string,
  },
  [DOCUMENT_KINDS.V5]: {
    checklist: LocalTexts.exampleDocuments.v5.checklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.v5.title') as string,
        src: v5Page1ExampleImage,
        title: LocalT.translate('pages.v5.inputs.1stPage.label') as string,
      },
      {
        alt: LocalT.translate('exampleDocuments.v5.title') as string,
        src: v5Page2ExampleImage,
        title: LocalT.translate('pages.v5.inputs.2ndPage.label') as string,
      },
      {
        alt: LocalT.translate('exampleDocuments.v5.title') as string,
        src: v5Page3ExampleImage,
        title: LocalT.translate('pages.v5.inputs.3rdPage.label') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.v5.title') as string,
  },
  [DOCUMENT_KINDS.BANK_STATEMENT]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.bank_statement.title') as string,
        src: bankStatementExampleImage,
        title: LocalT.translate('exampleDocuments.bank_statement.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.bank_statement.title') as string,
  },
  [DOCUMENT_KINDS.UTILITY_BILL]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.utility_bill.title') as string,
        src: proofOfPurchaseAddressImage,
        title: LocalT.translate('exampleDocuments.utility_bill.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.utility_bill.title') as string,
  },
  [DOCUMENT_KINDS.LETTER_OF_CONSENT]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.letter_of_consent.title') as string,
        src: letterOfConsentExampleImage,
        title: LocalT.translate('exampleDocuments.letter_of_consent.title') as string,
      },
    ],
  },
  [DOCUMENT_KINDS.WILL]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.will.title') as string,
        src: willExampleImage,
        title: LocalT.translate('exampleDocuments.will.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.will.title') as string,
  },
  [DOCUMENT_KINDS.PASSPORT]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.passport.title') as string,
        src: passportExampleImage,
        title: LocalT.translate('exampleDocuments.passport.title') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.passport.title') as string,
  },
  [DOCUMENT_KINDS.SOLICITORS_LETTER]: {
    checklist: LocalTexts.exampleDocuments.commonChecklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.solicitors_letter.title') as string,
        src: solicitorsLetterExampleImage,
        title: LocalT.translate('exampleDocuments.solicitors_letter.title') as string,
      },
    ],
  },
  [DOCUMENT_KIND_PROOF_OF_ADDRESS]: {
    checklist: LocalTexts.exampleDocuments.proof_of_address.checklist,
    images: [
      {
        alt: LocalT.translate('exampleDocuments.proof_of_address.title') as string,
        src: proofOfPurchaseAddressImage,
        title: LocalT.translate('pages.proof_of_address.inputs.1stPage.label') as string,
      },
      {
        alt: LocalT.translate('exampleDocuments.proof_of_address.title') as string,
        src: bankStatementExampleImage,
        title: LocalT.translate('pages.proof_of_address.inputs.2ndPage.label') as string,
      },
      {
        alt: LocalT.translate('exampleDocuments.proof_of_address.title') as string,
        src: councilTaxExampleImage,
        title: LocalT.translate('pages.proof_of_address.inputs.3rdPage.label') as string,
      },
    ],
    title: LocalT.translate('exampleDocuments.proof_of_address.title') as string,
  },
};
